import { axiosService } from 'ui-model';

// TODO rrubenich avoid importing from `@lumahealthhq/ui-model`
// eslint-disable-next-line no-restricted-imports
import { createQueryKey, useQuery, UseQueryOptions } from '@lumahealthhq/ui-model';

const basePath = 'chatActivities';

export function useChatActivityCountUnread(
  params: { limit?: number; assignee?: string },
  options?: UseQueryOptions<number>,
) {
  const basePathUnread = `${basePath}/unread`;
  const variant = 'v2/{basePath}';

  async function queryFn() {
    const url = variant.replace('{basePath}', basePathUnread);
    const { data } = await axiosService.get<{ count: number }>(url, { params });
    return data.count;
  }

  const queryKey = createQueryKey(basePathUnread, variant, params);
  const queryResult = useQuery(queryKey, queryFn, options);
  return queryResult;
}
